<template>
    <div class="for-media">
        <post-back :title="tr.for_media" />
        <div class="container">
            <br/>
            <br/>
            <div >
                <h2 class="u-c">{{tr.press_office}}</h2>
                <div class="row">
                    <div class="col-sm-4">
                        <br/>
                        <span style='font-size:22px;font-weight:bold'>{{tr.ms_zarina_seifullina}}</span>
                        <p>{{tr.media_director}}</p>
                        <br/>
                        <p style="font-size:16px;">{{tr.pr_phone}}
                            <br/>{{tr.pr_email}}</p>
                            <a href="/for_media.pdf" target="_blank"> {{tr.fpp_lib}}</a>
                    </div>
                    <div class="col-sm-8 text-center">
                        <h2>{{tr.for_media_message_title}}</h2>
                        <p style='font-size:18px;'>{{tr.for_media_message_text}}</p>
                    </div>
                </div>
            </div>
            <br/>
            <br/>
            <br/>
            <br/>
            <div class="form">
                <h3 class="u-c text-center">{{tr.subscribe_for_press_release}}</h3>
                <input type="text" :placeholder="tr.fio" v-model="fio">
                <input type="text" :placeholder="tr.jobtitle" v-model="jobtitle">
                <input type="text" :placeholder="tr.smi" v-model="smi">
                <input type="text" placeholder="Email" v-model="email">
                <input type="text" :placeholder="tr.phone_number" v-model="phone">
                <button @click="send">{{tr.send_reply}}</button>
            </div>
            <br/>
            <hr>
            <br/>
            <br/>
            <h2 class="u-c text-center">{{tr.press_releases}}</h2>
            <posts-grid :posts="posts.slice(0,6)" :paginator="false" />
        </div>
        <br>
        <br>
        <br>
    </div>
</template>
<script>
import PostsGrid from "./posts-grid.vue";

export default {
    name: 'for-media',
    components: { PostsGrid },
    methods: {
        send() {
            let {tr} = this;
            let { fio, jobtitle, smi, email, phone } = this;
            if (!fio || !jobtitle || !smi || !email || !phone) {
                alert(tr.fill_all_please);
            } else {
                this.$http.post("content/notify",{form:{fio, jobtitle, smi, email, phone_number:phone }})
                alert(tr.delivered);

                this.fio = "";
                this.jobtitle = "";
                this.smi = "";
                this.email = "";
                this.phone = "";
            }
        }
    },

    computed: {
        seo(){return {title:this.trRaw.for_media, description: this.trRaw.fot_media_meta_description}},
        posts() { return this.$store.getters.pressReleases; },
    },
    data() {
        return {
            fio: "",
            jobtitle: "",
            smi: "",
            email: "",
            phone: ""
        }
    }
}
</script>
<style lang="css" scoped>
.form input {
    border-radius: 4px;
    padding: 8px 16px;
    border: 1px solid lightgrey;
    width: 100%;
    margin: 6px;
}

.form {
    background: whitesmoke;
    border-radius: 6px;
    margin: 4px;
    padding: 16px;
    overflow: hidden;
    margin-bottom: 40px;
    width: 576px;
    margin: auto;
}

@media(max-width:576px) {
    .form {
        width: 100%;
    }
}

.form button {
    border-radius: 4px;
    padding: 4px 8px;
    float: right;
}

.avatar {
    border: 2px solid lightgrey;
    border-radius: 100%;
    width: 180px;
}
</style>